export default __webpack_public_path__ + "assets/3d75f77b7daf0424f5998f219a965d6c.png";